import { createSlice } from '@reduxjs/toolkit';

const userData = createSlice({
  name: 'userData',
  initialState: {
    value: '', 
    menuOpen: false
  },
  reducers: {
    updateValue: (state, action) => {
      state.value = action.payload; 
    },
    updateMenuOpen: (state, action) => {
      state.menuOpen = action.payload; 
    },
  },
});

export const { updateValue, updateMenuOpen } = userData.actions;
export default userData.reducer;